import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'

function FaqSection() {

    const [card,setCard]=useState(0)

    //""

const [header,setHeader]=useState(0)

  useEffect(()=>{
    const interval=setInterval(()=>{
      setHeader(prevCount=>(prevCount+1)%5)
    },5000)
return ()=>{clearInterval(interval)}
  },[])
const dynamicHeader=()=>{
  if(header===0){
    return "https://i.pinimg.com/736x/58/ce/a4/58cea41c219f2a23db2299934dcd0adb.jpg"
  }else if(header===1){
    return "https://i.pinimg.com/736x/46/68/59/46685966ebe46146c765727d747d4ff9.jpg"

  }else if(header===2){
    return "https://i.pinimg.com/1200x/b7/7c/eb/b77ceb683462f50cab7a9707a909428d.jpg"
  }else if(header===3){
    return "https://i.pinimg.com/736x/5c/a9/41/5ca941944a5f298aa44ad02ee698c89e.jpg"

  }else{
    return "https://i.pinimg.com/736x/9f/b8/38/9fb8381208ca14ed5eebc3ecf2cb2d93.jpg"

  }
}

  return (
    <>
      <section class="section__container faq__container" id="faq">
  <div class="faq__image">
    <img src={dynamicHeader()} alt="faq" />
  </div>

  <div class="faq__content">
    <h3 class="section__subheader">Ask The Chef</h3>
    <h2 class="section__header">Frequently Asked Questions</h2>
    <p class="section__description">
      Get answers to your questions about personalized menus, catering services, 
      bookings, and everything else from The Roaming Chef.
    </p>

    <div class="faq__grid">
      <div className={card===0?"faq__card active ":"faq__card"} onClick={()=>{setCard(0)}}>
        <div class="faq__header">
          <h4>What type of food do you cook?</h4>
          <span><i class="ri-arrow-down-s-line"></i></span>
        </div>
        <div class="faq__description">
          I create personalized menus inspired by African flavors, global cuisines, 
          and seasonal ingredients. Each event is tailored to your taste and theme.
        </div>
      </div>

      <div className={card===1?"faq__card active ":"faq__card"} onClick={()=>{setCard(1)}}>
        <div class="faq__header">
          <h4>How can I book you for an event?</h4>
          <span><i class="ri-arrow-down-s-line"></i></span>
        </div>
        <div class="faq__description">
          You can book directly through the website form, send an email, 
          or contact me via WhatsApp. Once I have your details, we’ll plan 
          the perfect menu for your occasion.
        </div>
      </div>

      <div className={card===2?"faq__card active ":"faq__card"} onClick={()=>{setCard(2)}}>
        <div class="faq__header">
          <h4>Do you travel outside Nairobi?</h4>
          <span><i class="ri-arrow-down-s-line"></i></span>
        </div>
        <div class="faq__description">
          Yes! I cater events across Kenya and beyond, depending on availability. 
          Travel and logistics can be arranged as part of your booking.
        </div>
      </div>

          <NavLink to="/faq">
          <h3 class="section__subheader">Read More</h3>
      
      </NavLink>
        </div>
      </div>
    </section>

    </>
  )
}

export default FaqSection
